export default __webpack_public_path__ + "static/media/paloateparo2.fbf1df8e.jpg";